import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ProductService} from '../../../../services/product.service';
import {Product} from '../../../../model/paypal/product';
import {NgbModalRef} from '@ng-bootstrap/ng-bootstrap/modal/modal-ref';
import {NgbModal, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';
import {ModalWindowComponent} from '../../../../components/dropdown-menu1/modal-window.component';

@Component({
  selector: 'app-product',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.css']
})
export class ProductListComponent implements OnInit {

  private ascDirection = 1;

  title: string;
  products: Product[];

  page = 1;
  count = 0;
  pageSize = 20;

  searchId: any;
  searchName: any;
  searchActive: boolean = true;
  searchSubTotal: any;
  searchTax: any;

  criteria: string;

  columnFilter: string;
  valueFilter: string;

  alert: boolean = false;
  alertMessage: string;

  modalRef: NgbModalRef;
  modalOptions: NgbModalOptions;

  constructor(private router: Router,
              private route: ActivatedRoute,
              private productService: ProductService,
              private changeDetector: ChangeDetectorRef,
              private modalService: NgbModal) {
    this.title = 'Product';
    this.modalOptions = {
      backdrop: 'static',
      backdropClass: 'customBackdrop'
    };
  }

  ngOnInit(): void {
    this.reloadData();
    if (this.route.snapshot.queryParams['messageData'] != null) {
      this.viewMessage(this.route.snapshot.queryParams['messageData']);
    }
  }

  viewMessage(message: string): void {
    this.alert = true;
    this.alertMessage = message;
    setTimeout(() => {
      this.alert = false;
      this.changeDetector.detectChanges();
    }, 3000);
  }

  reloadData(): void {
    this.productService.findAll()
      .toPromise()
      .then((products: Product[]) => {
        products = this.sorting(products);
        products = this.filter(products);

        this.products = products;
        this.changeDetector.detectChanges();
      });
  }

  handlePageChange(event: number): void {
    this.page = event;
  }

  create(): void {
    this.router.navigate(['/product'],
      {
        queryParams: {
          productId: 0,
          mode: 'create'
        }
      });
  }

  edit(id: number): void {
    this.router.navigate(['/product'],
      {
        queryParams: {
          productId: id,
          mode: 'edit'
        }
      });
  }

  delete(id: number): void {
    this.makeQuestion('Product will remove. Are you agree?');
    this.modalRef.result.then((result) => {
      console.log('false');
    }, (reason) => {
      this.productService.delete(id)
        .toPromise()
        .then((result) => {
          this.reloadData();
          this.viewMessage(result.answer);
        })
        .catch((error) => {
          this.router.navigate(['/error'],
            {
              queryParams:
                {
                  errorCode: error.status
                }
            });
        });
    });
  }

  private makeQuestion(question: string): void {
    this.modalRef = this.modalService.open(ModalWindowComponent);
    this.modalRef.componentInstance.my_modal_title = 'Question';
    this.modalRef.componentInstance.my_modal_content = question;
  }

  sortBy(criteria: string): void {
    this.criteria = criteria;
    this.reloadData();
  }

  changeFilterValue(column: string, value: any): void {
    this.columnFilter = column;
    this.valueFilter = value;
    this.reloadData();
  }

  private sorting(products: Product[]): Product[] {
    if (this.ascDirection === -1) {
      switch (this.criteria) {
        case 'id':
          products.sort((a, b) => a.id > b.id ? 1 : -1);
          break;
        case 'active':
          products.sort((a, b) => (a.active === b.active) ? 0 : a.active ? -1 : 1);
          break;
        case 'name':
          products.sort((a, b) => a.name.localeCompare(b.name));
          break;
        case 'subTotal':
          products.sort((a, b) => a.subTotal > b.subTotal ? 1 : -1);
          break;
        case 'tax':
          products.sort((a, b) => a.tax > b.tax ? 1 : -1);
          break;
        default:
          break;
      }
      this.ascDirection = 1;
    } else {
      switch (this.criteria) {
        case 'id':
          products.sort((a, b) => b.id > a.id ? 1 : -1);
          break;
        case 'active':
          products.sort((a, b) => (a.active === b.active) ? 0 : b.active ? -1 : 1);
          break;
        case 'name':
          products.sort((a, b) => b.name.localeCompare(a.name));
          break;
        case 'subTotal':
          products.sort((a, b) => b.subTotal > a.subTotal ? 1 : -1);
          break;
        case 'tax':
          products.sort((a, b) => b.tax > a.tax ? 1 : -1);
          break;
        default:
          break;
      }
      this.ascDirection = -1;
    }
    return products;
  }

  private filter(products: Product[]): Product[] {
    if (this.columnFilter !== undefined && this.valueFilter !== undefined) {
      products = products.filter((product) => {
        switch (this.columnFilter) {
          case 'id':
            return String(product.id).includes(this.valueFilter);
            break;
          case 'active':
            return this.valueFilter ? !product.active : product.active;
            break;
          case 'name':
            return String(product.name.toLowerCase()).includes(this.valueFilter.toLowerCase());
            break;
          case 'subTotal':
            return String(product.subTotal).includes(this.valueFilter);
            break;
          case 'tax':
            return String(product.tax).includes(this.valueFilter);
            break;
          default:
            break;
        }
      });
    }
    return products;
  }
}
